import ChargeBeeInvoicesMonitoringLogList from './chargebeeinvoicesmonitoringloglistmodel-list-screen.vue';

export default {
    components: {
        'charge_bee_invoices_monitoring_log_list': ChargeBeeInvoicesMonitoringLogList
    },

    data: function () {
        return {
            loading: false,
            appId: this.$route.params.id ?? 0,
            model: this.emptyModel(),
        }
    },

    computed: {

    },

    methods: {
        refreshScreen() {
            this.appId = this.$route.params.id ?? 0;
            this.senderId = this.$route.params.senderId ?? 0;
            this.onLoadModelDataSource();
        },

        emptyModel() {
            return {
                AppId: 0,
            }
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                let url = '/api/ui/chargebee_invoices_applications/load/' + this.appId;
                let response = await this.$http.get(url);
                this.model = response.body;

                this.$refs.charge_bee_invoices_monitoring_log_list.channelSettings = {
                    ApplicationId: this.model.AppId
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: function () {
        this.refreshScreen();
    }
}